import { Documento } from '../../models/Documento';


export const listaFormularios: Documento[] = [
    {
        id: 1,
        titulo: 'Solicitud de Usuarios para Sistema NI y NP',
        descripcion: 'Solicitud de Usuarios para Sistema NI y NP',
        urlpdf: 'https://drive.google.com/file/d/1jybcl_tUg4lDYn4mUVbc259DgcXLDXGR/view?usp=sharing'
    },
    {
        id: 2,
        titulo: 'Solicitud de usuario para el supervisor',
        descripcion: 'Solicitud de usuario para el supervisor',
        urlpdf: 'https://drive.google.com/file/d/1j-1XgyXVf7sWrykZlXwB5DMbujAtTjA1/view?usp=sharing'
    },
    {
        id: 3,
        titulo: 'Registro de alumno SInIDE-SGE 01',
        descripcion: 'Registro de alumno SInIDE-SGE 01',
        urlpdf: 'https://drive.google.com/file/d/1InMLzUydvRQ4AaL0MYA94kpEfl5w61ee/view?usp=sharing'
    },
    {
        id: 4,
        titulo: 'Planilla de edición de datos Personales SGE',
        descripcion: 'Planilla de edición de datos Personales SGE',
        urlpdf: 'https://drive.google.com/file/d/1Vw7r-xo8e-G8lU5mIMHAPeOyqHeY_t50/view?usp=sharing'
    },
    {
        id: 5,
        titulo: 'Planilla datos Director y ViceDirector y Secretario',
        descripcion: 'Planilla datos Director y ViceDirector y Secreatarios',
        urlpdf: 'https://drive.google.com/file/d/1NvlDtX50nJrFQVkyV9H65OcQpz29lL66/view?usp=sharing'
    },
    {
        id: 6,
        titulo: 'Acta compromiso para el director',
        descripcion: 'Acta compromiso para el director',
        urlpdf: 'https://drive.google.com/file/d/1LUdxPLiycXm7LCrxRCTbwJaR2LmpNaDN/view?usp=sharing'
    }

]

export const formulariosRa: Documento[] = [
  {
      id: 1,
      titulo: 'GUIA RELEVAMIENTO ANUAL 2025',
      descripcion: 'GUIA RELEVAMIENTO ANUAL 2025',
      urlpdf: 'https://drive.google.com/file/d/16P3ImDRoWeMyzXjjNRI5BKglJk03gin4/view?usp=sharing'
  },
  {
      id: 2,
      titulo: 'ADULTOS TP',
      descripcion: 'ADULTOS TP',
      urlpdf: 'https://drive.google.com/file/d/1eaSfRQYB8NAawG36hq2rSbjjlZ8QugkK/view?usp=sharing'
  },
  {
      id: 3,
      titulo: 'ARITISTICA',
      descripcion: 'ARITISTICA',
      urlpdf: 'https://drive.google.com/file/d/1xM8D-rGbqgiwZjEw8_3lR4-LMrzJiDgh/view?usp=sharing'
  },
  {
      id: 4,
      titulo: 'COMUN-TP',
      descripcion: 'COMUN-TP',
      urlpdf: 'https://drive.google.com/file/d/1RMIpbLswX86kObo7sKlmOiJRTYbLggVy/view?usp=sharing'
  },
  {
      id: 5,
      titulo: 'ESPECIAL',
      descripcion: 'ESPECIAL',
      urlpdf: 'https://drive.google.com/file/d/10hOm_hvoE2tbtHv-es5VVlp0dXA6O9SL/view?usp=sharing'
  },
  {
      id: 6,
      titulo: 'FORM-PROFE-CAP-LABORAL',
      descripcion: 'FORM-PROFE-CAP-LABORAL',
      urlpdf: 'https://drive.google.com/file/d/1WiLJ_oO-56O4tH7wiWorDmi0bsrJIyau/view?usp=sharing'
  },
  {
      id: 7,
      titulo: 'COMPLEMENTARIO',
      descripcion: 'COMPLEMENTARIO',
      urlpdf: 'https://drive.google.com/file/d/1JTuPiImE1K450JGn1WUvhUXCnxP8q7Do/view?usp=sharing'
  },
  {
      id: 8,
      titulo: 'SUPERIOR-TP',
      descripcion: 'SUPERIOR-TP',
      urlpdf: 'https://drive.google.com/file/d/1Q9k28A-8ueHeWQ7iDymOC_oi8d0whAQi/view?usp=sharing'
  }
]
